import { useEffect } from 'react'

const RTL_LANGUAGES = ['ar', 'fa', 'he']

// Keeps <html lang> and <html dir> in sync with the UI language, so screen
// readers pick the right voice and right-to-left scripts lay out correctly.
export const useDocumentLanguage = language => {
	useEffect(() => {
		document.documentElement.lang = language
		document.documentElement.dir = RTL_LANGUAGES.includes(language) ? 'rtl' : 'ltr'
	}, [language])
}
